<template>
    <div class="ma-5">
        <v-data-table
                :headers="headers"
                :items="desserts"
                :height="320"
                :fixed-header="true"
                :search="search"
                class="elevation-3"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Cadastro de Comprador</v-toolbar-title>
                    <v-divider
                            class="mx-4"
                            inset
                            vertical
                    ></v-divider>

                    <v-spacer></v-spacer>

                    <v-text-field class="mr-10"
                                  v-model="search"
                                  append-icon="mdi-magnify"
                                  label="Pesquisar"
                                  single-line
                                  hide-details
                    ></v-text-field>
                    <v-dialog persistent v-model="dialog" max-width="600px">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark class="mb-2" v-on="on">Novo</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                         <v-col class="pa-0" cols="12" xs="12">
                                            <v-text-field
                                                    outlined
                                                    v-model="editedItem.nome_completo"
                                                    label="Digite o nome do Comprador*"
                                                    autofocus
                                                    color="#042333"
                                                    item-text="nome_completo"
                                                    item-value="id"
                                                    :error-messages="compradorErrors"
                                                    @input="$v.editedItem.nome_completo.$touch()"
                                                    @blur="$v.editedItem.nome_completo.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Sair</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </v-toolbar>
            </template>

            <template v-slot:item.src_modulo="{ item }">
                <v-icon>{{item.src_modulo}}</v-icon>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                        title="Editar Módulo"
                        class="mr-2"
                        @click="editItem(item)"
                >
                mdi-pencil
                </v-icon>
                <v-icon
                        title="Remover Módulo"
                        @click="deleteItem(item)"
                >
                mdi-delete
                </v-icon>
            </template>

        </v-data-table>
    </div>
</template>
<script>
    import {required} from 'vuelidate/lib/validators'
    import Api from "./../../api/cfg";

    export default {
        data: () => ({
            dialog: false,
            atualizar: 0,
            search: '',
            headers: [
                {
                    text: 'ID',
                    value: 'id',
                },
                {
                    text: 'Nome Comprador',
                    align: 'left',
                    value: 'nome_completo',
                },
                {text: 'Ações', value: 'action', sortable: false},
            ],
            desserts: [],
            editedIndex: -1,
            editedItem: {
                id: '',
                nome_completo: '',
            },
            defaultItem: {
                id: '',
                nome_completo: '',

            },
            selects: {
                compradores: {
                    items: [],
                }
            }
        }),

        validations: {
            editedItem: {
                nome_completo: {
                    required,
                },

            }
        },
        
        computed: {
            compradorErrors() {
                const errors = []
                if (!this.$v.editedItem.nome_completo.$dirty) return errors
                !this.$v.editedItem.nome_completo.required && errors.push('Campo Obrigatório.')
                return errors
            },
            formTitle() {
                return this.editedIndex === -1 ? 'Novo Comprador' : 'Editar Comprador'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },
        },

        created() {
            this.initialize()
        },

        methods: {
            initialize() {

                const headers = this.Helpers.iniciarRequisicao();

                Api.getCompradores(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {

                            this.desserts = response.data.compradores;

                        }

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })

                this.$store.dispatch("loading/habilitarLoading", false);

            },

            editItem(item) {
                this.editedIndex = this.desserts.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },
            
            deleteItem(item) {

                this.editedItem = Object.assign({}, item)

                if (confirm('Deseja remover o Comprador?')) {
                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        Api.delComprador(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {

                                    this.initialize();

                                    //atualizar componente fornecedor
                                    this.$emit("novoComprador", this.atualizar += 1)

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                }

                this.close()

            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },

            save() {

                if (!this.$v.$invalid) {
                    
                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        Api.addComprador(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {

                                    this.initialize();

                                    //atualizar componente fornecedor
                                    this.$emit("novoComprador", this.atualizar += 1)

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                    this.close()
                }
            },
        },
    }
</script>
<style scoped>
</style>